module.exports = __webpack_public_path__ + "static/media/cadillac-logo.86e139ba.png";